export interface TrajetFaq {
  q: string;
  a: string;
}

export interface TrajetRoute {
  slug: string;
  from: string;
  to: string;
  wilaya: number;
  distance: string;
  duration: string;
  priceRange: string;
  frequency: string;
  departsPerDay: string;
  intro: string;
  faqs: TrajetFaq[];
  related: string[];
}

export const TRAJET_ROUTES: TrajetRoute[] = [
  {
    slug: 'alger-tizi-ouzou',
    from: 'Alger',
    to: 'Tizi-Ouzou',
    wilaya: 15,
    distance: '118 km',
    duration: '1h30 – 2h30',
    priceRange: '280 – 420 DA',
    frequency: 'Toutes les 20 à 40 min (04h00 – 18h30)',
    departsPerDay: '~90 départs / jour',
    intro: 'Plus de 90 bus par jour depuis Kharouba vers Tizi-Ouzou. Le vendredi matin et le dimanche soir, la gare se remplit vite — vérifie les places avant de partir.',
    faqs: [
      {
        q: 'Combien coûte le billet bus Alger–Tizi-Ouzou ?',
        a: 'Entre 280 et 420 DA selon le transporteur. Le tarif exact s\'affiche en temps réel sur idaNroh.',
      },
      {
        q: 'Quelle est la durée du trajet Alger–Tizi-Ouzou ?',
        a: '1h30 à 2h30 selon la circulation sur la RN12. Le vendredi, compte 30 min de plus.',
      },
      {
        q: 'De quelle gare partent les bus pour Tizi-Ouzou ?',
        a: 'Gare routière de Kharouba (El Harrach, Alger). Arrivée à la gare routière principale de Tizi-Ouzou.',
      },
      {
        q: 'Quand prendre le bus pour éviter la foule ?',
        a: 'Le mardi et mercredi matin. Évite le vendredi et dimanche soir : c\'est l\'heure de pointe maximale.',
      },
    ],
    related: ['alger-bejaia', 'alger-bouira', 'alger-setif'],
  },
  {
    slug: 'alger-bejaia',
    from: 'Alger',
    to: 'Béjaïa',
    wilaya: 6,
    distance: '260 km',
    duration: '3h00 – 4h30',
    priceRange: '480 – 650 DA',
    frequency: 'Toutes les 30 à 60 min (04h30 – 17h00)',
    departsPerDay: '~50 départs / jour',
    intro: 'Environ 50 bus par jour pour Béjaïa depuis Kharouba, via la RN26 ou par Tizi-Ouzou. En été et les week-ends, les places du matin s\'épuisent vite.',
    faqs: [
      {
        q: 'Quel est le prix du billet Alger–Béjaïa ?',
        a: 'Entre 480 et 650 DA. Les bus confort sont en haut de fourchette.',
      },
      {
        q: 'Combien de temps dure le trajet Alger–Béjaïa ?',
        a: '3h à 4h30 selon la route (RN26 directe ou via Tizi-Ouzou) et le trafic.',
      },
      {
        q: 'Y a-t-il des arrêts intermédiaires ?',
        a: 'Certains bus s\'arrêtent à Boumerdès ou Tizi-Ouzou. L\'arrêt et le prix correspondant sont indiqués sur idaNroh.',
      },
      {
        q: 'Quels jours éviter pour le bus Alger–Béjaïa ?',
        a: 'Les week-ends d\'été (juillet–août) et les veilles de fêtes. Le mardi et mercredi sont les plus calmes.',
      },
    ],
    related: ['alger-tizi-ouzou', 'alger-setif', 'alger-constantine'],
  },
  {
    slug: 'alger-constantine',
    from: 'Alger',
    to: 'Constantine',
    wilaya: 25,
    distance: '435 km',
    duration: '5h00 – 6h30',
    priceRange: '800 – 1 050 DA',
    frequency: 'Toutes les heures (04h00 – 16h00)',
    departsPerDay: '~30 départs / jour',
    intro: 'Constantine est à 435 km et 5 à 6h de route depuis Kharouba. Une trentaine de bus par jour — pour un trajet aussi long, vérifie les places avant de te déplacer à la gare.',
    faqs: [
      {
        q: 'Combien coûte le bus Alger–Constantine ?',
        a: 'Entre 800 et 1 050 DA. Les bus climatisés et de nuit sont légèrement plus chers.',
      },
      {
        q: 'Quelle est la durée du trajet Alger–Constantine ?',
        a: '5h à 6h30 selon les arrêts (Sétif, Aïn M\'lila). Les express sans arrêt font moins de 5h.',
      },
      {
        q: 'Y a-t-il des bus de nuit Alger–Constantine ?',
        a: 'Oui, certains transporteurs ont des départs tardifs. Vérifie les horaires disponibles aujourd\'hui sur idaNroh.',
      },
      {
        q: 'Quand est-il plus calme de voyager vers Constantine ?',
        a: 'Mercredi et jeudi matin. Évite le vendredi soir et les veilles de jours fériés.',
      },
    ],
    related: ['alger-setif', 'alger-bejaia', 'alger-annaba'],
  },
  {
    slug: 'alger-oran',
    from: 'Alger',
    to: 'Oran',
    wilaya: 31,
    distance: '360 km',
    duration: '4h00 – 5h30',
    priceRange: '650 – 850 DA',
    frequency: 'Toutes les heures (04h00 – 17h00)',
    departsPerDay: '~25 départs / jour',
    intro: '25 bus par jour vers Oran via l\'autoroute Est-Ouest. Le vendredi, les places s\'épuisent dès le matin — arrive tôt ou vérifie avant de te déplacer.',
    faqs: [
      {
        q: 'Quel est le prix du bus Alger–Oran ?',
        a: 'Entre 650 et 850 DA selon le transporteur. Les bus avec clim et bagages inclus sont en haut de fourchette.',
      },
      {
        q: 'Combien de temps dure le bus Alger–Oran ?',
        a: '4h à 5h30 via l\'autoroute Est-Ouest, avec parfois un arrêt à Chlef ou Relizane.',
      },
      {
        q: 'Y a-t-il des bus de nuit Alger–Oran ?',
        a: 'Oui, des départs nocturnes existent chez certains transporteurs. Vérifie les créneaux du jour sur idaNroh.',
      },
      {
        q: 'À quelle gare arrivent les bus à Oran ?',
        a: 'Gare routière principale d\'Oran, Hay El Sabah. Certains transporteurs privés ont des arrêts différents.',
      },
    ],
    related: ['alger-tlemcen', 'alger-medea', 'alger-blida'],
  },
  {
    slug: 'alger-setif',
    from: 'Alger',
    to: 'Sétif',
    wilaya: 19,
    distance: '300 km',
    duration: '3h30 – 4h30',
    priceRange: '540 – 720 DA',
    frequency: 'Toutes les 40 à 60 min (04h00 – 17h00)',
    departsPerDay: '~35 départs / jour',
    intro: '35 bus par jour pour Sétif depuis Kharouba. Beaucoup passent par Bouira — vérifie l\'arrêt de ton bus et le prix correspondant sur idaNroh.',
    faqs: [
      {
        q: 'Quel est le prix du billet Alger–Sétif ?',
        a: 'Entre 540 et 720 DA. Les bus avec arrêt à Bouira sont parfois moins chers.',
      },
      {
        q: 'Quelle est la durée du trajet Alger–Sétif ?',
        a: '3h30 à 4h30 selon la route. Les express via l\'autoroute sont les plus rapides.',
      },
      {
        q: 'Les bus Alger–Sétif s\'arrêtent-ils à Bouira ?',
        a: 'Oui, beaucoup font un arrêt à Bouira. idaNroh affiche le tarif exact selon ton arrêt.',
      },
      {
        q: 'Quels jours éviter pour le bus Alger–Sétif ?',
        a: 'Le lundi (jour de marché à Sétif) et le vendredi. Le mardi est le jour le plus calme.',
      },
    ],
    related: ['alger-constantine', 'alger-bejaia', 'alger-bouira'],
  },
  {
    slug: 'alger-bouira',
    from: 'Alger',
    to: 'Bouira',
    wilaya: 10,
    distance: '110 km',
    duration: '1h30 – 2h15',
    priceRange: '230 – 340 DA',
    frequency: 'Toutes les 30 min (04h30 – 18h00)',
    departsPerDay: '~55 départs / jour',
    intro: 'Bouira est à 110 km de Kharouba, très fréquenté par les étudiants et travailleurs pendulaires. 55 bus par jour, départ toutes les 30 min.',
    faqs: [
      {
        q: 'Combien coûte le bus Alger–Bouira ?',
        a: 'Entre 230 et 340 DA selon le transporteur.',
      },
      {
        q: 'Combien de temps dure le trajet Alger–Bouira ?',
        a: '1h30 à 2h15 selon le trafic. L\'autoroute Est-Ouest raccourcit le trajet.',
      },
      {
        q: 'À quelle heure est-il plus facile d\'avoir une place ?',
        a: 'En dehors des heures de pointe (7h–9h et 17h–19h). Consulte idaNroh pour voir l\'occupation en temps réel.',
      },
      {
        q: 'Les bus Alger–Bouira passent-ils par d\'autres wilayas ?',
        a: 'Certains bus Sétif ou Constantine s\'arrêtent à Bouira — idaNroh les inclut dans les résultats.',
      },
    ],
    related: ['alger-tizi-ouzou', 'alger-setif', 'alger-medea'],
  },
  {
    slug: 'alger-blida',
    from: 'Alger',
    to: 'Blida',
    wilaya: 9,
    distance: '50 km',
    duration: '45 min – 1h30',
    priceRange: '150 – 220 DA',
    frequency: 'Plusieurs départs le matin et le soir',
    departsPerDay: '~10 départs / jour via SOGRAL',
    intro: 'SOGRAL a peu de départs pour Blida depuis Kharouba. Pour ce trajet court, le train SNTF ou les bus urbains depuis Alger-Centre sont souvent plus pratiques.',
    faqs: [
      {
        q: 'Combien coûte le bus Alger–Blida ?',
        a: 'Entre 150 et 220 DA via SOGRAL. Le train SNTF est souvent plus direct pour ce trajet.',
      },
      {
        q: 'Y a-t-il des alternatives au bus pour aller à Blida ?',
        a: 'Oui, le train SNTF et les bus urbains depuis Alger-Centre couvrent ce trajet régulièrement.',
      },
      {
        q: 'De quelle gare partent les bus Alger–Blida ?',
        a: 'Gare de Kharouba pour SOGRAL. Les bus privés peuvent partir d\'autres points dans Alger.',
      },
      {
        q: 'Combien de temps dure le trajet Alger–Blida ?',
        a: '45 min à 1h30 selon la circulation et la route (autoroute ou RN1).',
      },
    ],
    related: ['alger-tipaza', 'alger-medea', 'alger-oran'],
  },
  {
    slug: 'alger-boumerdes',
    from: 'Alger',
    to: 'Boumerdès',
    wilaya: 35,
    distance: '40 km',
    duration: '45 min – 1h15',
    priceRange: '140 – 200 DA',
    frequency: 'Plusieurs départs dans la journée',
    departsPerDay: '~15 départs / jour',
    intro: 'Boumerdès est desservie par des bus en transit vers Béjaïa et Tizi-Ouzou qui s\'arrêtent en route. idaNroh détecte ces bus et affiche le tarif de l\'arrêt intermédiaire.',
    faqs: [
      {
        q: 'Quel est le prix du bus Alger–Boumerdès ?',
        a: 'Environ 140 à 200 DA. Les bus en transit depuis Béjaïa ou Tizi-Ouzou peuvent avoir des prix légèrement différents.',
      },
      {
        q: 'Combien de temps dure le trajet Alger–Boumerdès ?',
        a: '45 min à 1h15 selon la circulation sur l\'autoroute Est-Ouest.',
      },
      {
        q: 'Des bus venant d\'autres destinations s\'arrêtent-ils à Boumerdès ?',
        a: 'Oui, les bus Alger–Béjaïa et Alger–Tizi-Ouzou passent par Boumerdès — idaNroh les inclut automatiquement.',
      },
      {
        q: 'Y a-t-il d\'autres transports pour Boumerdès depuis Alger ?',
        a: 'Les taxis collectifs et bus urbains couvrent aussi ce trajet depuis le centre d\'Alger.',
      },
    ],
    related: ['alger-bejaia', 'alger-tizi-ouzou', 'alger-constantine'],
  },
  {
    slug: 'alger-tipaza',
    from: 'Alger',
    to: 'Tipaza',
    wilaya: 42,
    distance: '70 km',
    duration: '1h00 – 1h45',
    priceRange: '190 – 280 DA',
    frequency: 'Plusieurs départs le matin',
    departsPerDay: '~12 départs / jour',
    intro: '12 départs par jour pour Tipaza depuis Kharouba, surtout concentrés le matin. Vérifie les places disponibles avant de te déplacer.',
    faqs: [
      {
        q: 'Quel est le prix du bus Alger–Tipaza ?',
        a: 'Entre 190 et 280 DA selon le transporteur et la saison.',
      },
      {
        q: 'Combien de temps dure le trajet Alger–Tipaza ?',
        a: '1h à 1h45. La route côtière (RN11) est plus longue ; l\'autoroute est plus rapide.',
      },
      {
        q: 'Y a-t-il des bus directs Alger–Tipaza ?',
        a: 'Oui, plusieurs bus SOGRAL desservent Tipaza directement. Certains bus vers Cherchell ou Aïn Defla s\'y arrêtent aussi.',
      },
      {
        q: 'Quelle est la meilleure heure pour partir vers Tipaza ?',
        a: 'Les premiers départs avant 8h sont les moins chargés.',
      },
    ],
    related: ['alger-blida', 'alger-oran', 'alger-medea'],
  },
  {
    slug: 'alger-medea',
    from: 'Alger',
    to: 'Médéa',
    wilaya: 26,
    distance: '90 km',
    duration: '1h30 – 2h00',
    priceRange: '240 – 350 DA',
    frequency: 'Toutes les 45 min (05h00 – 18h00)',
    departsPerDay: '~20 départs / jour',
    intro: '20 bus par jour pour Médéa depuis Kharouba, via le col de Chréa. En hiver la route peut être fermée en cas de neige — vérifie avant de partir.',
    faqs: [
      {
        q: 'Combien coûte le bus Alger–Médéa ?',
        a: 'Entre 240 et 350 DA. Les bus en transit pour Djelfa ou Ouargla qui s\'arrêtent à Médéa peuvent avoir des tarifs différents.',
      },
      {
        q: 'Combien de temps dure le bus Alger–Médéa ?',
        a: '1h30 à 2h. La route de montagne peut être rallongée en hiver.',
      },
      {
        q: 'Y a-t-il des bus pour Médéa toute la journée ?',
        a: 'Oui, de 05h00 à 18h00 environ. Les premiers bus du matin sont les moins chargés.',
      },
      {
        q: 'Des bus longue distance s\'arrêtent-ils à Médéa ?',
        a: 'Oui, les bus Alger–Djelfa, Alger–Laghouat et Alger–Ouargla marquent souvent un arrêt à Médéa.',
      },
    ],
    related: ['alger-bouira', 'alger-blida', 'alger-oran'],
  },
  {
    slug: 'alger-tlemcen',
    from: 'Alger',
    to: 'Tlemcen',
    wilaya: 13,
    distance: '558 km',
    duration: '6h00 – 8h00',
    priceRange: '900 – 1 200 DA',
    frequency: 'Quelques départs par jour (05h00 – 14h00)',
    departsPerDay: '~10 départs / jour',
    intro: '558 km, 6 à 8h de route, une dizaine de bus par jour. Pour Tlemcen les places partent vite — vérifie avant de te déplacer à Kharouba.',
    faqs: [
      {
        q: 'Quel est le prix du bus Alger–Tlemcen ?',
        a: 'Entre 900 et 1 200 DA, c\'est l\'un des trajets les plus longs depuis Kharouba.',
      },
      {
        q: 'Combien de temps dure le bus Alger–Tlemcen ?',
        a: '6h à 8h selon les arrêts (Relizane, Sidi Bel Abbès). Certains express sont plus rapides.',
      },
      {
        q: 'Y a-t-il des bus de nuit Alger–Tlemcen ?',
        a: 'Certains transporteurs proposent des départs tardifs pour arriver à Tlemcen le matin.',
      },
      {
        q: 'Quels arrêts entre Alger et Tlemcen ?',
        a: 'Chlef, Relizane, Mascara et Sidi Bel Abbès. idaNroh affiche le prix pour chaque arrêt.',
      },
    ],
    related: ['alger-oran', 'alger-medea', 'alger-blida'],
  },
  {
    slug: 'alger-annaba',
    from: 'Alger',
    to: 'Annaba',
    wilaya: 23,
    distance: '525 km',
    duration: '5h30 – 7h00',
    priceRange: '850 – 1 100 DA',
    frequency: 'Plusieurs départs le matin et début d\'après-midi',
    departsPerDay: '~12 départs / jour',
    intro: '525 km jusqu\'à Annaba, 5h30 à 7h de route via Sétif et Guelma. Une douzaine de bus depuis Kharouba — vérifie les places disponibles avant de partir.',
    faqs: [
      {
        q: 'Quel est le tarif bus Alger–Annaba ?',
        a: 'Entre 850 et 1 100 DA. Les bus climatisés confort sont en haut de fourchette.',
      },
      {
        q: 'Combien de temps dure le bus Alger–Annaba ?',
        a: '5h30 à 7h selon les arrêts (Sétif, Guelma). Les express font le trajet en environ 5h30.',
      },
      {
        q: 'Y a-t-il des arrêts entre Alger et Annaba ?',
        a: 'Oui, Sétif, Constantine et Guelma. Le tarif de chaque arrêt intermédiaire est visible sur idaNroh.',
      },
      {
        q: 'Quels jours sont les plus chargés sur Alger–Annaba ?',
        a: 'Le vendredi et les veilles de fêtes. Viens tôt le matin pour être sûr d\'avoir une place.',
      },
    ],
    related: ['alger-constantine', 'alger-setif', 'alger-bejaia'],
  },
];

export const TRAJET_MAP = Object.fromEntries(TRAJET_ROUTES.map((r) => [r.slug, r]));
